<template>
  <pack class="cms-balance">
    <zt-title>余额增减</zt-title>
    <el-form label-width="120px" label-position="left">
      <el-form-item label="手机号" :error="telephoneError" required>
        <zt-input width="282px" v-model.trim="params.telephone" @input="trimSpace" type="tel" @blur="onTelephoneBlur(params.telephone)"/>
        <span class="cms-commission" v-show="cmsCommission">当前余额￥{{ cmsCommission }}</span>
      </el-form-item>
      <el-form-item label="增减" required>
        <el-radio-group v-model="radio">
          <el-radio label="+">增加</el-radio>
          <el-radio label="-">减少</el-radio>
        </el-radio-group>
        <zt-input width="140px" class="ml8" v-model="params.commission" type="number" :min="0"/>
        <span class="ml8">元</span>
      </el-form-item>
      <el-form-item label="调整后余额">
        <span v-if="computedBalance">￥{{ computedBalance }}</span>
        <span v-else>-</span>
      </el-form-item>
      <el-form-item label="修改备注" required :error="resonError">
        <zt-input type="textarea" width="282px" rows="4" v-model="params.reson" @blur="onResonBlur"/>
      </el-form-item>
      <el-form-item label-width="0">
        <zt-button type="primary" @click="onSubmitClick" :disabled="!canSubmit" :loading="loading">确定操作</zt-button>
      </el-form-item>
    </el-form>

    <pack>
      <el-date-picker v-bind="pickerBind" class="mb16" v-model="pickerModel"/>
      <el-table :data="tableData" v-loading="tableLoading">
        <el-table-column label="修改时间">
          <span slot-scope="{ row }">{{ row.addtime_ymd}}<br>{{ row.addtime_hms}}</span>
        </el-table-column>
        <el-table-column label="手机号码" prop="telephone"></el-table-column>
        <el-table-column label="用户别名">
          <template slot-scope="{ row }">
            {{ row.alias_name || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="修改金额" prop="num"></el-table-column>
        <el-table-column label="备注" prop="remark" min-width="200px"></el-table-column>
      </el-table>

      
      <!-- 分页器 -->
      <div class="pagination">
        <el-pagination @size-change="tableParams.pagesize = $event" @current-change="tableParams.page = $event" v-bind="paginationBind"/>
      </div>
    </pack>
  </pack>
</template>

<script>
import { taoke_cms_member_list } from '@/api/userManage'
import dayjs from 'dayjs'
const YMDHMS = 'YYYY-MM-DD HH:mm:ss'

import {
  taoke_cms_member_commission_modify,
  taoke_cms_member_commission_modify_log
} from '@/api/finance'
export default {
  name: 'cmsBalance',
  data: () => ({
    loading: false,
    params: {
      telephone: '',
      commission: 0,
      reson: '',
    },
    radio: '+',
    recordcount: 0,

    cmsCommission: 0, // cms账号余额
    backupTelephone: '',  // 发送请求成功的电话号码备份

    telephoneError: '', // 手机号码错误信息
    resonError: '',

    tableParams: {
      telephone: '',
      begin_time: dayjs().subtract(3, 'month').startOf('day').format(YMDHMS),
      end_time: dayjs().endOf('day').format(YMDHMS),
      page: 1,
      pagesize: 10,
    },
    tableData: [],
    tableLoading: false,
  }),

  computed: {
    // 调整后余额
    computedBalance: (vm) => {
      console.log(111, eval(vm.cmsCommission + vm.radio + (vm.params.commission - 0 || 0)).toFixed(2));
      
      return eval(vm.cmsCommission + vm.radio + (vm.params.commission - 0 || 0)).toFixed(2)
    },

    // 是否可以提交
    canSubmit: (vm) => vm.backupTelephone === vm.params.telephone && vm.params.telephone && vm.params.commission - 0 && vm.params.reson,

    // 分页属性
    paginationBind: (vm) => ({
      currentPage: vm.tableParams.page,
      pageSize: vm.tableParams.pagesize,
      pageSizes: [ 10, 20, 30, 40 ],
      layout: 'total, sizes, prev, pager, next, jumper',
      total: vm.recordcount,
    }),

    // 日期选择器属性
    pickerBind: () => ({
      type: 'daterange',
      rangeSeparator: '至',
      startPlaceholder: '开始日期',
      endPlaceholder: '结束日期',
      defaultTime: [ '00:00:00', '23:59:59' ],
    }),

    pickerModel: {
      get() {
        return [ this.tableParams.begin_time, this.tableParams.end_time ]
      },
      set(val) {
        this.tableParams.begin_time = dayjs(val[0]).format(YMDHMS)
        this.tableParams.end_time = dayjs(val[1]).format(YMDHMS)
      },
    },
  },

  watch: {
    'params.telephone'() {
      this.telephoneError = ''
      this.backupTelephone = ''
    },

    tableParams: {
      immediate: true,
      deep: true,
      handler() {
        this.getLog(true)
      },
    },
  },

  methods: {
    trimSpace(val) {
      if (val.indexOf(' ') !== -1) {
        this.params.telephone = this.params.telephone.replace(/\s+/g, '');
      }
    },
    // 手机号码失去焦点，获取用户信息
    async onTelephoneBlur(telephone) {
      if (!telephone) return this.telephoneError = '请输入手机号码'
      if (telephone.length < 11) return this.telephoneError = '手机号不存在'

      const { data } = await taoke_cms_member_list({ telephone })
      
      if (data.error_code == 0 && data.list.length) {
        this.cmsCommission = data.list[0].commission
        this.backupTelephone = telephone
      }
      else {
        this.backupTelephone = ''
        this.telephoneError = data.error_message || '手机号不存在'
      }
    },

    // 提交修改
    async onSubmitClick() {
      this.loading = true

      const params = {
        ...this.params,
        commission: this.radio + this.params.commission,
      }
      const { data } = await taoke_cms_member_commission_modify(params)
      if (data.error_code == 0) {
        this.$message.success('设置成功')
        this.params.telephone = ''
        this.params.commission = 0
        this.params.reson = ''
        this.cmsCommission = 0
        this.backupTelephone = ''

        if (this.tableParams.page == 1) {
          this.getLog()
        }
        else {
          this.tableParams.page = 1
        }
      }
      else {
        this.$message.error(data.error_message)
      }

      this.loading = false
    },

    // 获取修改记录
    async getLog(toTop) {
      this.tableLoading = true
      const { data } = await taoke_cms_member_commission_modify_log(this.tableParams)
      if (data.error_code == 0) {
        this.tableData = data.list
        this.tableData.map(function(list) { //拆分日期
          if(list.addtime!=''&&list.addtime!=undefined) {
            list.addtime_ymd = list.addtime.split(' ')[0]
            list.addtime_hms = list.addtime.split(' ')[1]
          }
        })
        this.recordcount = data.recordcount
        if (toTop) {
          window.scrollTo(0, 0);
        }
      }
      else {
        this.tableData = []
        this.$message.error(data.error_message)
      }
      this.tableLoading = false
    },

    // 备注输入框失去焦点
    onResonBlur() {
      if (!this.params.reson) {
        this.resonError = '请输入备注'
      }
      else {
        this.resonError = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 16px;
  text-align: right;
}

.cms-commission {
  margin-left: 8px;
  color: $theme-green;
}
</style>